import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import './index.css'
import { unregister as unregisterServiceWorker } from './registerServiceWorker'

import { Router, Route } from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import { ThemeProvider } from 'styled-components'
import theme from './theme.js'

import App from 'containers/App'

import combineReducers from './redux/reducers'
const middleware = []
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(combineReducers, composeEnhancers(applyMiddleware(...middleware)))

window.onload = (e) => {
  setTimeout(() => {
    store.dispatch({ type: 'WINDOW_LOADED' })
  }, 1500)
}

const customHistory = createBrowserHistory()
customHistory.listen(location => {
  store.dispatch({ type: 'PATH_UPDATE', location })
})
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <Router history={customHistory}>
        <Route path='/' component={App} />
      </Router>
    </Provider>
  </ThemeProvider>
  , document.getElementById('root'))
unregisterServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js